"use client";

import { useState, useEffect, useRef } from "react";
import ProfileWheel from "./profile-wheel";
import type Profile from "../types/profile";
import sendMessage from "../hooks/sendMessage";

interface GiveawayProps {
  showWheel: boolean;
  profiles: Profile[];
  winnerr: Profile;
  onAnimationComplete?: () => void;
}

export default function Giveaway({
  showWheel,
  profiles,
  winnerr,
  onAnimationComplete,
}: Readonly<GiveawayProps>) {
  const [isRolling, setIsRolling] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [winner, setWinner] = useState<Profile | null>(null);
  const soundPlayedRef = useRef(false); // Add this ref to track sound played state

  useEffect(() => {
    let timeouts: NodeJS.Timeout[] = [];

    if (showWheel) {
      setIsVisible(true);
      soundPlayedRef.current = false; // Reset sound played state

      timeouts.push(
        setTimeout(() => {
          if (winnerr) {
            setWinner(winnerr);

            if (!soundPlayedRef.current && !isRolling) {
              playSound();
              soundPlayedRef.current = true;
            }
            setIsRolling(true);
            timeouts.push(
              setTimeout(() => {
                setIsRolling(false);
                onAnimationComplete?.();
              }, 9200),
            );
          }
        }, 1500),
      );
    } else {
      setIsVisible(false);
      setIsRolling(false);
      setWinner(null);
      soundPlayedRef.current = false; // Reset sound played state when wheel hides
    }

    return () => {
      timeouts.forEach(clearTimeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showWheel, winnerr, onAnimationComplete]);

  function playSound() {
    const audio = new Audio("/whoosh.mp3");
    audio.volume = 0.3;
    audio.play().catch((err) => {
      console.error("Sound playback failed:", err);
      soundPlayedRef.current = false; // Reset on error
    });
  }

  return (
    <main
      className={`roulette bg-gray-50 transition-transform duration-1000 ease-in-out ${
        isVisible ? "translate-x-0" : "-translate-x-[2000px]"
      }`}
    >
      <ProfileWheel
        profiles={profiles}
        winner={winner}
        isRolling={isRolling}
        reset={!showWheel}
        onAnimationComplete={() => {
          setTimeout(() => {
            sendMessage(`🎁 @${winner?.name} has won the giveaway!`).catch(
              (e) => console.error("Failed to send message:", e),
            );
          }, 5000);
        }}
      />
    </main>
  );
}
